"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const Concatenation_1 = require("../../../data/utilities/Concatenation");
const AssignmentsContext_1 = require("../../assignment/AssignmentsContext");
const highlight_1 = require("../../highlight");
const useActiveSpectrumZonesViewState_1 = require("../../hooks/useActiveSpectrumZonesViewState");
const scale_1 = require("../utilities/scale");
const SignalCrosshair_1 = __importDefault(require("./SignalCrosshair"));
function Signal({ signal }) {
    const scaleX = (0, scale_1.useScale2DX)();
    const scaleY = (0, scale_1.useScale2DY)();
    const buildIDs = (0, react_1.useCallback)((id) => {
        return [id].concat((0, Concatenation_1.buildID)(id, 'X'), (0, Concatenation_1.buildID)(id, 'Y'));
    }, []);
    const assignment = (0, AssignmentsContext_1.useAssignment)(signal.id);
    const { showSignals, showPeaks } = (0, useActiveSpectrumZonesViewState_1.useActiveSpectrumZonesViewState)();
    const highlight = (0, highlight_1.useHighlight)(buildIDs(assignment.id));
    const highlightData = (0, highlight_1.useHighlightData)();
    const [isHighlighted, setIsHighlighted] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (highlightData.highlight.highlighted.some((_highlighted) => buildIDs(signal.id).includes(_highlighted)) ||
            assignment.isActive) {
            setIsHighlighted(true);
        }
        else {
            setIsHighlighted(false);
        }
    }, [
        assignment.isActive,
        buildIDs,
        highlightData.highlight.highlighted,
        signal.id,
    ]);
    if (!signal)
        return null;
    return ((0, jsx_runtime_1.jsxs)("g", { className: "zone-signal", children: [showSignals && ((0, jsx_runtime_1.jsxs)("g", { children: [(0, jsx_runtime_1.jsx)(SignalCrosshair_1.default, { signal: signal }), (0, jsx_runtime_1.jsx)("circle", { onMouseEnter: () => {
                            assignment.show();
                            highlight.show();
                        }, onMouseLeave: () => {
                            assignment.hide();
                            highlight.hide();
                        }, cx: scaleX(signal.x.delta || 0), cy: scaleY(signal.y.delta || 0), r: isHighlighted ? 6 : 4, fill: isHighlighted ? 'green' : 'darkgreen' }, signal.id)] })), (0, jsx_runtime_1.jsx)("g", { className: "zone-signal-peak", style: { pointerEvents: 'none' }, children: showPeaks &&
                    signal?.peaks?.map((peak, i) => ((0, jsx_runtime_1.jsx)("circle", { cx: scaleX(peak.x), cy: scaleY(peak.y), r: 2, fill: "black" }, `${signal.id + i}`))) })] }));
}
exports.default = Signal;
